import React, { InputHTMLAttributes, ChangeEvent} from "react";
import Datepicker from "react-datepicker";
import cn from "classnames"
import et from "date-fns/locale/et";
import ru from "date-fns/locale/ru";
import { registerLocale } from  "react-datepicker";
import { getLocale, t } from "../../i18n";
import { getISODateString } from "../../utils/datetime";

const needsDatepicker = ((): boolean => {
  const date = document.createElement("input");
  date.type = "date";
  return date.type !== "date";
})();

if (needsDatepicker) {
  registerLocale("et", et);
  registerLocale("ru", ru);
}

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  onChange: (v: null | string | ChangeEvent<HTMLInputElement>) => void;
}

interface Props {
  className?: string;
  i18key?: string;
  input: InputProps;
  topLabel?: string;
  topLabelClass?: string;
  small?: boolean;
}

const Input = (props: Props): JSX.Element => {
  const { i18key, input } = props
  const { disabled, onChange, value } = input

  const className = cn("Input Input--filled", props.className, {
    "Input--disabled": disabled,
  })

  return (
    <label className={cn(className, { "Input--small": props.small })}>
      <span className={props.topLabelClass}>{props.topLabel}</span>
      {needsDatepicker && (
        <Datepicker
          className={cn("Input-input", { "Input--small Input-date--small" : props.small })}
          dateFormat="dd.MM.yyyy"
          disabled={disabled}
          locale={getLocale()}
          maxDate={input.max ? new Date(input.max): null}
          minDate={input.min ? new Date(input.min) : null}
          onChange={(value: Date) => onChange && onChange(getISODateString(value)) }
          selected={value ? new Date(value as string) : null}
        />
      )}
      {!needsDatepicker && <input {...input} type="date" max={input.max} className={cn("Input-input", {
        "Input--small Input-date--small" : props.small
      })}/>}
      <span className="Input-label">{t(i18key)}</span>
    </label>
  )
}

export default Input
